import React from 'react'

import FatButton from '../../../buttons/fat-button/FatButton';
import FileUpload from '../../../../common/FileUpload';

import {UploadSchemaContext} from '../context/UploadSchemaContext';

type SchemaFileUploadProps = {
  afterUpload: () => void;
}

type SchemaFileUploadState = {
  toggle: boolean;
}

/**
 * A component which can handle selection of yaml file for upload.
 */
class SchemaFileUpload extends React.Component<SchemaFileUploadProps, SchemaFileUploadState> {

  static contextType = UploadSchemaContext;

  constructor(props: any) {
    super(props);
    this.state = {
      toggle: false
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidUpdate() {
    if (!this.context.uploading && !this.context.loading && this.context.file) {
      this.props.afterUpload();
    }
  }

  changeHandler(selectedFiles: Array<File>) {
    this.context.uploadSchema(selectedFiles);
  }

  clickHandler() {
    this.setState({
      toggle: !this.state.toggle
    })
  }

  render() {
    return (
      <>
      <FatButton className="upload-schema-btn" icon="upload" title="Upload Schema"
                 descr="Supports single *.yaml or *.yml file upload"
                 clickHandler={this.clickHandler}/>
      <FileUpload toggle={this.state.toggle} changeHandler={this.changeHandler} multiple={false}
                  accept=".yaml,.yml" hidden={true}/>
      </>
    );
  }
}

export default SchemaFileUpload;
